<template>
  <div
    id="dashboard"
    :class="{
      mobileMode: ['mobile', 'tablet'].includes($mq),
      deskMode: !['mobile', 'tablet'].includes($mq),
    }"
  >
    <el-container
      id="topContainer"
      :class="{
        blurMode: blurFlag
      }"
    >
      <mq-layout mq="laptop+">
        <el-aside>
          <Aside />
        </el-aside>
      </mq-layout>

      <el-container id="secondContainer">
        <el-header :style="cssProps">
          <!-- <el-header> -->
          <Header />
        </el-header>

        <el-main id="mainContents">
          <Main />

          <el-footer
            v-if="!['mobile', 'tablet'].includes($mq)"
            style="position: sticky; top: 100%; height: 40px;"
          >
            <Footer />
          </el-footer>
        </el-main>

        <el-footer
          v-if="['mobile', 'tablet'].includes($mq)"
          class="mobileFooter"
        >
          <MobileMenu />
        </el-footer>
      </el-container>
    </el-container>

    <transition
      name="el-fade-in-linear"
      mode="out-in"
    >
      <!-- 48 * 48 -->
      <el-button
        v-if="showGroove"
        class="contactUsBtn"
        circle
        @click="openGroove"
      >
        <div>?</div>
      </el-button>

      <el-button
        v-else-if="customHelpBtn"
        class="contactUsBtn"
        circle
        @click="openHelp"
      >
        <div>?</div>
      </el-button>
    </transition>

    <BlurDialog
      v-if="blurFlag"
      :blur-flag="blurFlag"
      :blur-option="blur.option"
    />

    <LeaderDemographics
      v-if="showDemographics && !showCongrats"
      :show="showDemographics"
      @closeModal="initAppcues"
    />

    <CompletedDialog
      v-if="display_congrats_modal && showCongrats"
      :show.sync="showCongrats"
    />

    <LeaderEngagementPaused
      v-if="user.role_type === 'leader'"
      :show.sync="showEngagementPaused"
    />
  </div>
</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import * as Sentry from '@sentry/browser';
import Aside from './layout/Aside.vue';
import Main from './layout/Main.vue';
import Header from './layout/Header.vue';
import Footer from './layout/Footer.vue';
import MobileMenu from './layout/MobileMenu.vue';
import BlurDialog from './widget/BlurDialog.vue';
import LeaderDemographics from './widget/LeaderDemographics.vue';
import LeaderEngagementPaused from './widget/LeaderEngagementPaused.vue';
import CompletedDialog from './widget/CompletedDialog.vue';

export default {
  components: {
    Aside,
    Main,
    Header,
    Footer,
    MobileMenu,
    BlurDialog,
    LeaderDemographics,
    LeaderEngagementPaused,
    CompletedDialog,
  },

  data() {
    return {
      showGroove: false,
      showCongrats: false,
      showEngagementPaused: false,
    };
  },

  computed: {
    ...mapGetters('user', {
      hasTimezone: 'hasTimezone',
    }),

    ...mapGetters('user', {
      theme: 'getTheme',
    }),

    ...mapState({
      user: (state) => state.user.user,
      userProfile: (state) => state.user.profile,
      process: (state) => state.processStatus.process,
      session_id: (state) => state.processStatus.process.session_id,
      blur: (state) => state.user.blur,
      user_demographics: (state) => state.user.profile.demographics,
      display_congrats_modal: (state) => state.processStatus.process.display_congrats_modal,
    }),

    cssProps() {
      if (process.env.VUE_APP_SERVICE === 'gcg_platform' && ['mobile', 'tablet'].includes(this.$mq) && this.theme) {
        return {
          backgroundImage: this.theme.background_color,
        };
      }
      return null;
    },

    blurFlag() {
      if (process.env.VUE_APP_ENV === 'local') return false;
      return this.blur.flag;
    },

    showDemographics() {
      let flag = false;
      if (this.user && this.userProfile && !this.userProfile.is_invited
        && this.user.role_type === 'leader'
        && !this.blurFlag && !this.user_demographics) {
        flag = true;
      }
      return flag;
    },

    customHelpBtn() {
      let flag = false;
      if (!this.showGroove
        && process.env.VUE_APP_SERVICE === 'ing_gcg_platform'
        && ['leader', 'coach', 'OA'].includes(this.user.role_type)) {
        flag = true;
      }
      return flag;
    },
  },

  watch: {
    session_id(sessionId) {
      Sentry.configureScope((scope) => {
        scope.setUser({
          uuid: this.user.uuid,
          role_type: this.user.role_type,
          session_id: sessionId,
        });
      });
    },

    // Status from state
    display_congrats_modal: {
      handler(newValue) {
        this.showCongrats = newValue;
      },
    },

    // Modal status with turn on/off event
    showCongrats: {
      immediate: true,
      handler(newValue) {
        this.confetti(newValue ? 'on' : 'off');
      },
    },
  },

  async created() {
    try {
      await this.fetchCurrentUser();
    } catch (err) {
      if (err.key && err.key === 'demographicsIncomplete') {
        this.$router.push({ name: 'confirmYourRegistration' });
      }
    }

    switch (this.user.role_type) {
      case 'leader':
        this.fetchProcess();
        this.fetchCoach();
        this.fetchLGAs();
        break;
      case 'coach':
        this.removeProcess();
        this.fetchCoachAlerts();
        break;
      case 'OA':
        this.removeProcess();
        break;
      case 'MAM':
        this.removeProcess();
        break;
      default:
    }

    this.fetchNewCount();
  },

  mounted() {
    // groovehq

    // const isING = process.env.VUE_APP_SERVICE === 'ing_gcg_platform';
    // if (!isING && window.groove && ['leader', 'coach', 'OA'].includes(this.user.role_type)) {
    //   if (this.user.role_type === 'coach') {
    //     window.groove.widget('setWidgetId', process.env.VUE_APP_GROOVE_WIDGET_COACH);
    //   } else if (this.user.role_type === 'OA') {
    //     window.groove.widget('setWidgetId', process.env.VUE_APP_GROOVE_WIDGET_OA);
    //   } else {
    //     window.groove.widget('setWidgetId', process.env.VUE_APP_GROOVE_WIDGET_LEADER);
    //   }
    //   window.groove.widget('load');
    //   window.groove.widget('setCustomer', {
    //     email: this.user.email,
    //   });

    //   setTimeout(() => {
    //     this.showGroove = true;
    //   }, 700);
    // } else {
    //   window.groove.widget('unload');
    // }

    // const fileName = this.user.role_type === 'coach'
    //   ? `${process.env.BASE_URL}javascript/groovehq_${process.env.VUE_APP_SERVICE}_coach.js`
    //   : `${process.env.BASE_URL}javascript/groovehq_${process.env.VUE_APP_SERVICE}.js`;
    let fileName;

    switch (this.user.role_type) {
      case 'coach':
        fileName = `${process.env.BASE_URL}javascript/groovehq_${process.env.VUE_APP_SERVICE}_coach.js`;
        break;
      case 'leader':
        fileName = `${process.env.BASE_URL}javascript/groovehq_${process.env.VUE_APP_SERVICE}.js`;
        break;
      case 'OA':
        fileName = `${process.env.BASE_URL}javascript/groovehq_oa.js`;
        break;
      default:
        fileName = '';
    }

    try {
      // eslint-disable-next-line no-undef
      groove.widget.destroy();
    } catch (error) {
      console.log('No groove widget');
    }
    let grooveScript = document.getElementById('grv-widget');
    if (grooveScript) {
      grooveScript.parentNode.removeChild(grooveScript);
    }

    if (['leader', 'coach', 'OA'].includes(this.user.role_type)) {
      grooveScript = document.createElement('script');
      grooveScript.setAttribute('src', fileName);
      grooveScript.setAttribute('id', 'grv-widget');
      document.head.appendChild(grooveScript);
    }

    // sentry
    Sentry.configureScope((scope) => {
      scope.setUser({
        uuid: this.user.uuid,
        role_type: this.user.role_type,
      });
    });

    if (this.user.role_type === 'leader' && this.process.curr_engagement_status === 'exception') {
      this.showEngagementPaused = true;
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.user.role_type === 'leader' && this.process.curr_engagement_status === 'exception') {
      this.showEngagementPaused = true;
    }
    next();
  },

  beforeDestroy() {
    try {
      // eslint-disable-next-line no-undef
      groove.widget.destroy();
    } catch (error) {
      console.log('No groove widget');
    }
    this.showGroove = false;
  },

  methods: {
    ...mapActions('processStatus', [
      'fetchProcess',
    ]),

    ...mapActions('myCoach', [
      'fetchCoach',
    ]),

    ...mapActions('myLGAs', [
      'fetchLGAs',
    ]),

    ...mapActions('notifications', [
      'fetchNewCount',
    ]),

    ...mapActions('coachAlerts', [
      'fetchCoachAlerts',
    ]),

    ...mapActions('user', [
      'fetchCurrentUser',
    ]),

    ...mapMutations('processStatus', [
      'removeProcess',
    ]),

    setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    openGroove() {
      if (window.groove) {
        window.groove.widget('open');
      }
    },

    openHelp() {
      let url = 'https://ingkb.gcgroup.io/help';
      if (this.user.role_type === 'OA') { url = 'https://oakb.gcgroup.io/help'; }
      if (this.user.role_type === 'coach') { url = 'https://coachkb.gcgroup.io/help'; }
      window.open(url, '_blank');
    },

    confetti(option) {
      // Option on, off
      if (option === 'on') {
        this.$confetti.start({
          // canvasId: 'dialogCanvas',
          particles: [
            { type: 'rect' },
            { type: 'rect' },
            { type: 'heart' },
            { type: 'circle' },
            { type: 'circle' },
          ],
          particlesPerFrame: 1.5,
          windSpeedMax: 1.2,
          defaultDropRate: 8,
          defaultSize: 10,
        });
      } else {
        this.$confetti.stop();
        // this.toggleClaim();
      }
    },

    initAppcues() {
      if (process.env.VUE_APP_PLATFORM === 'ING') {
        window.Appcues.show('4187aadb-5ca8-44b9-8f20-532a969e9ec0');
      }
    },
  },
};
</script>

<style lang="scss">
#dashboard {
  overflow: hidden;

  #topContainer {
    &.blurMode {
      pointer-events: none;
      filter: blur(3px);
    }
  }

  .el-container {
    height: 100%;
  }

  .el-aside {
    width: 224px !important;
    height: 100%;
    background: var(--themeCardColor);
    overflow-x: hidden;
  }

  .el-header {
    width: 100%;
    min-width: 320px;
    margin: 0 auto;
    padding: 0 20px 0 0;
  }

  .el-main,
  .el-footer {
    min-width: 320px;
    padding: 0;
  }

  .el-main {
    scrollbar-color: #c8c8c8 transparent;
    overflow-y: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c8c8c8;
      border-radius: 20px;
    }

    &::-webkit-scrollbar-track {
      background: transparent !important;
    }
  }

  .el-footer.mobileFooter {
    position: fixed;
    width: 100vw;
    left: 0;
    z-index: 99999;
    bottom: 0 !important;
    transition: top 200ms ease-in-out;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

  // v-loading style
  .el-loading-mask {
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 950;
    transition: all 200ms ease-in-out;
    line-height: normal;
    margin: -1px -1px -1px -1px;
  }

  .contactUsBtn {
    position: fixed;
    bottom: 20px;
    right: 25px;
    font-size: 20px;
    color: #003865;
    z-index: 999;
    width: 61px;
    font-weight: 600;
    border: 5px solid #003865;

    span {
      font-size: 25px;
    }
  }

  // Dashboard Desktop css
  &.deskMode {
    height: 100%;

    .el-main {
      height: calc(100vh - 60px);
    }
  }

  // Dashboard Mobile css
  &.mobileMode {
    .el-header {
      position: fixed;
      width: 100vw;
      height: 65px !important;
      top: 0;
      left: 0;
      z-index: 1000;
      // background-image: radial-gradient(circle at bottom left, #2dc0c7, #32166b);
      background-image: radial-gradient(circle at bottom left, #28aeb5, #2b145f);
      background-size: 100vw 100vh;
    }

    .el-main {
      margin-top: 65px;
      width: 100vw;
      -webkit-overflow-scrolling: unset;

      &::-webkit-scrollbar {
        width: 0;
      }
    }

    .el-footer {
      // Set forced position for ONLY iOS Landscape
      @supports (-webkit-overflow-scrolling: touch) {
        @media (min-aspect-ratio: 1/1) {
          bottom: unset;
          top: calc(var(--vh, 1vh) * 100 - 60px);
        }
      }
    }

    .contactUsBtn {
      bottom: 80px;

      // For ONLY iOS Landscape
      @supports (-webkit-overflow-scrolling: touch) {
        @media (min-aspect-ratio: 1/1) {
          bottom: unset;
          top: calc(var(--vh, 1vh) * 100 - 120px);
        }
      }
    }

    // // Header assuming itself transparent but has to cover contents when scrolled
    // // It's not necessary for gradient but image.
    // @media (min-aspect-ratio: 1/1) {
    //   // Landscape
    //   .el-header {
    //     background-size: 100vw calc(100vh - 60px);
    //   }
    // }
    //
    // @media (max-aspect-ratio: 1/1) {
    //   // Orientation
    //   .el-header {
    //     background-size: auto 100vh;
    //   }
    // }
  }
}

.grv-widget-tag-bottom-right {
  // hide the groove button without hiding form
  // display: none also hide hide the form

  position: absolute;
  top: 0;
  right: -100vw !important;
}
</style>
